import {err} from 'framework';
import type {Result, ValidationError} from 'framework';
import type {CreateManualMealCommand} from '../../domain/create-manual-meal-command';
import type {DashboardError} from '../../domain/errors';
import type {MealDetail} from '../../domain/meal-detail';
import type {DashboardRepository} from '../ports/dashboard.repository';
import type {CreateManualMealCommandValidator} from '../validators/create-manual-meal-command.validator';

export interface CreateManualMealInput {
  readonly command: CreateManualMealCommand;
}

export class CreateManualMeal {
  constructor(
    private readonly dashboardRepository: DashboardRepository,
    private readonly validator: CreateManualMealCommandValidator,
  ) {}

  execute(
    input: CreateManualMealInput,
  ): Promise<Result<MealDetail, DashboardError | ValidationError>> {
    const valid = this.validator.validate(input.command);

    if (!valid.ok) {
      return Promise.resolve(err(valid.error));
    }

    return this.dashboardRepository.createManualMeal({command: valid.data});
  }
}
